import { createSlotRecipe } from './runtime.js';

const timePickerConfig = {"name":"timePicker","slots":["root","body","timeArea","highlightBar","colon","column","columnRoot","columnScroll","columnItem","footer","buttonGroup"],"defaultVariants":{"showFooter":false},"variantMap":{"showFooter":["false","true"]}}

export const timePicker = /* @__PURE__ */ createSlotRecipe(timePickerConfig)